module.exports = __webpack_public_path__ + "img/avatar5.e7eeb7a7.png";